<div class="location-disclosure">
  <div class="location-disclosure__icon">
    <ion-icon name="location-outline"></ion-icon>
  </div>
  <h3 class="location-disclosure__title">
    {{ "MODALS.LOCATION_DISCLOSURE.TITLE" | translate }}
  </h3>
  <p class="location-disclosure__message">
    {{ "MODALS.LOCATION_DISCLOSURE.MESSAGE" | translate }}
  </p>
  <ul class="location-disclosure__reasons">
    <li>{{ "MODALS.LOCATION_DISCLOSURE.REASON_1" | translate }}</li>
    <li>{{ "MODALS.LOCATION_DISCLOSURE.REASON_2" | translate }}</li>
    <li>{{ "MODALS.LOCATION_DISCLOSURE.REASON_3" | translate }}</li>
  </ul>
  <p class="location-disclosure__note">
    {{ "MODALS.LOCATION_DISCLOSURE.BACKGROUND_NOTE" | translate }}
  </p>
  <div class="location-disclosure__buttons">
    <app-button
      (onClick)="accept()"
      [innerText]="'MODALS.LOCATION_DISCLOSURE.ACCEPT' | translate"
    />
    <app-button
      [styles]="{ backgroundColor: '#1D5D9B80' }"
      (onClick)="decline()"
      [innerText]="'MODALS.LOCATION_DISCLOSURE.DECLINE' | translate"
    />
  </div>
</div>
